import Cookies from "js-cookie";
import axios from "axios";
import { getBaseUrl } from "../../utils";

const get_role = getBaseUrl() + "admin/subadmins";
const get_role_by_id = getBaseUrl() + "admin/role";
const status_update_role = getBaseUrl() + "admin/update_role";
const delete_role = getBaseUrl() + "admin/role";
const add_role = getBaseUrl() + "admin/subadmin";
const update_role = getBaseUrl() + "admin/role";

export const updateRole_api = async (data, roleId) => {
  let config = {
    method: "patch",
    url: update_role + `/${roleId}`,
    headers: { Authorization: `Bearer ${Cookies.get("med_token")}` },
    data: data,
  };
  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const addRole_api = async (data) => {
  let config = {
    method: "post",
    url: add_role,
    headers: { Authorization: `Bearer ${Cookies.get("med_token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const deleteRole_api = async (data) => {
  let config = {
    method: "delete",
    url: delete_role + `/${data?.id}`,
    headers: { Authorization: `Bearer ${Cookies.get("med_token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
export const status_update_role_api = async (data) => {
  let config = {
    method: "patch",
    url: status_update_role,
    headers: { Authorization: `Bearer ${Cookies.get("med_token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
export const getRole_api = async (data) => {
  let config = {
    method: "get",
    url:
      get_role + `?page=${data.page}&limit=${data.limit}&search=${data.search}`,
    headers: { Authorization: `Bearer ${Cookies.get("med_token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};

export const getRoleById_api = async (data, roleId) => {
  let config = {
    method: "get",
    url: get_role_by_id + `/${roleId}`,
    headers: { Authorization: `Bearer ${Cookies.get("med_token")}` },
    data: data,
  };

  try {
    let res = await axios(config);
    return res;
  } catch (error) {
    console.log(error);
    return error.response;
  }
};
